<template>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="parentData"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Equivalencia')">
              <a-input
                v-decorator="['equivalency', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Valor')">
              <a-input
                v-decorator="['value', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
</template>

<script>
  export default {
    props: ['id_equivalency'],
    data () {
      return {
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'equivalency_values',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Equivalencia', dataIndex: 'equivalency', sorter: true},
              {title: 'Valor', dataIndex: 'value', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'equivalency'},
            {name: 'value'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_equivalency: this.id_equivalency
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Equivalency/EquivalencyValues.vue